import React, { useEffect, useState } from "react";
import "./AddCategory.scss";
import InputField from "../../../components/InputField/InputField";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import { useForm } from "react-hook-form";
import {
  addCategory,
  fetchCategoriesByOrganization,
  updateCategory,
} from "../../../api/categories";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewCategory,
  replaceCategory,
  updateCategories,
} from "../../../redux/features/organization-slice";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import useUserIsAllowed from "../../../helpers/userAuthorized";

const AddCategory = ({
  isEdit,
  desktopView,
  selected,
  setSelectedDesktopTag,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentViewPort, isReady } = useViewPortDetector();

  const [categoryId, setCategoryId] = useState(null);

  const dispatch = useDispatch();

  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );

  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");
  const userIsAllowedToAddEditProduct = useUserIsAllowed(
    "create_or_edit_products"
  );

  const userIsAllowedToAddEditCategory =
    userIsAdministrator ||
    userIsAllowedToAddEditProduct ||
    userIsAllowedToManageInventory;

  useEffect(() => {
    if (!desktopView && currentViewPort === "desktop" && isReady) {
      navigate(ROUTES.categories.path);
    }
  }, [currentViewPort, isReady]);

  const {
    register,
    handleSubmit,
    reset,
    watch,
    formState: { errors },
  } = useForm({});

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const editData =
      isEdit && desktopView ? selected : isEdit ? location.state?.editData : {};
    if (isEdit) {
      if (!editData?.id) {
        !desktopView && navigate(ROUTES.categories.path);
      } else {
        setCategoryId(editData?.id);
        reset({
          name: editData?.name,
          description: editData?.description,
        });
      }
    } else {
      setCategoryId(null);
      reset({
        name: "",
        description: "",
      });
    }
  }, [isEdit, selected]);

  const handleAddCategory = (data) => {
    const categoryData = {
      name: data?.name,
      description: data?.description,
      organization_id: organization_id,
    };

    setSubmitting(true);

    if (!isEdit) {
      addCategory(categoryData)
        .then((res) => {
          toast.dismiss(); toast.success("New category added.");
          dispatch(addNewCategory({ category: res.data }));
          navigate(ROUTES.categories.path);
          setCategoryId(null);
          reset({
            name: "",
            description: "",
          });
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
            } else {
              toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss(); toast.error("Error while adding new category!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      updateCategory(categoryId, categoryData)
        .then((res) => {
          toast.dismiss(); toast.success("Category updated successfully.");
          dispatch(replaceCategory({ category: res.data }));
          navigate(ROUTES.categories.path);
          setCategoryId(null);
          reset({
            name: "",
            description: "",
          });
          setSelectedDesktopTag && setSelectedDesktopTag("Add Category");
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss();
                toast.error(
                  "You do not have sufficient permissions to perform this action. Please contact your administrator."
                );
            } else {
              toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss(); toast.error("Error while updating category!");
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };
  return (
    <div className="add-category">
      <form
        className="container-wrapper"
        onSubmit={handleSubmit(handleAddCategory)}
      >
        <div className="form-container">
          <InputField
            name={"name"}
            type={"text"}
            label={"Category Name"}
            required={true}
            register={register}
            inputErrors={errors}
            watch={watch}
            disabled={!userIsAllowedToAddEditCategory}
          />

          <InputField
            name={"description"}
            type={"text"}
            label={"Description"}
            required={false}
            register={register}
            inputErrors={errors}
            watch={watch}
            textArea={true}
            disabled={!userIsAllowedToAddEditCategory}
          />

          <div className="buttons">
            <CustomButton
              name={"Cancel"}
              color={"danger"}
              type={"button"}
              handleSubmit={() => {
                navigate(ROUTES.categories.path);
              }}
              disabled={submitting}
            />
            <CustomButton
              name={"Save"}
              color={"primary"}
              type={"submit"}
              handleSubmit={() => {}}
              disabled={submitting || !userIsAllowedToAddEditCategory}
              loader={submitting}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddCategory;
